var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"gl-mt-5 gl-flex gl-flex-wrap gl-gap-2 gl-text-subtle"},[_c('gl-sprintf',{attrs:{"message":_vm.s__(
        'TwoFactorAuth|Having trouble signing in? %{buttonStart}Recover your account%{buttonEnd}',
      )},scopedSlots:_vm._u([{key:"button",fn:function({ content }){return [_c('gl-button',{attrs:{"variant":"link","category":"tertiary","data-testid":"recovery-button"},on:{"click":function($event){return _vm.$emit('recover')}}},[_vm._v(_vm._s(content))])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }